import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';

const Button = ({
  children,
  onClick,
  type = 'button',
  className = '',
  loading = false,
  disabled = false,
  icon,
  tooltipId,
  tooltipContent,
  spin = false, // New prop: allow external control of spin
}) => {
  const showSpinner = loading || spin; // Show spinner if loading or explicitly told to spin

  return (
    <>
      <button
        type={type}
        onClick={onClick}
        className={`flex items-center justify-center font-bold py-2 px-4 rounded-md transition duration-300 ${
          showSpinner || disabled ? 'opacity-50 cursor-not-allowed' : ''
        } ${className}`}
        disabled={showSpinner || disabled}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltipContent}
      >
        {showSpinner && <FontAwesomeIcon icon={faSpinner} spin className={children ? "mr-2" : ""} />} {/* Always spin faSpinner */}
        {icon && !showSpinner && <FontAwesomeIcon icon={icon} className={children ? "mr-2" : ""} />} {/* Show custom icon only if not spinning */}
        {children}
      </button>
      {tooltipContent && <Tooltip id={tooltipId} />}
    </>
  );
};

export default Button;